/** Normalize hashtag / search chip for matching feed content. */
export function normalizeFeedTag(raw: string | null | undefined): string {
  return (raw || '').replace(/^#/, '').trim().toLowerCase();
}

const TAG_ALIASES: Record<string, string[]> = {
  linguistics: ['linguistics', 'лингвистик', 'corpus', 'корпусн'],
  nlp: ['nlp', 'natural language', 'обработк'],
  internship: ['internship', 'стажиров'],
  science: ['science', 'науч'],
  ai: ['ai', 'artificial', 'ии'],
  phd: ['phd', 'докторант'],
  grant: ['grant', 'грант'],
  research: ['research', 'исследоват'],
  article: ['article', 'стать', 'публикац'],
  publishing: ['publishing', 'публикац', 'издат'],
  scopus: ['scopus'],
  openaccess: ['openaccess', 'open access', 'открыт'],
};

/** True when item text/tags match the active hashtag chip. */
export function matchesFeedTag(
  tag: string,
  parts: Array<string | null | undefined>,
  tags: string[] = [],
): boolean {
  const needle = normalizeFeedTag(tag);
  if (!needle) return true;

  const haystack = [
    ...tags.map((item) => normalizeFeedTag(item)),
    ...parts.map((part) => (part || '').toLowerCase()),
  ].join(' ');

  if (haystack.includes(needle)) return true;

  const aliases = TAG_ALIASES[needle] ?? [needle];
  return aliases.some((alias) => haystack.includes(alias));
}
